import { Braces } from 'lucide-react';
import { useWorkspaceStore } from '@/stores/workspace-store';
import { useGlobalSchemaStore } from '../global-schema-store';
import { walkFunctions, connectionLabel } from './_schema-helpers';
import type { SearchItem, SearchProvider } from '../types';
import type { ConnectionConfig } from '@/types';

export const functionSearchProvider: SearchProvider = {
  id: 'functions',
  kind: 'function',
  list: (ctx) => {
    const schemas = useGlobalSchemaStore.getState().schemas;
    const connections = ctx.queryClient?.getQueryData<ConnectionConfig[]>(['connections']) ?? [];
    const items: SearchItem[] = [];

    for (const loc of walkFunctions(schemas)) {
      const connName = connectionLabel(connections, loc.connectionId);
      items.push({
        id: `function:${loc.connectionId}:${loc.database}:${loc.schema}.${loc.function.name}`,
        kind: 'function',
        label: loc.function.name,
        subtitle: `Function · ${loc.schema} · ${loc.database} · ${connName}`,
        icon: Braces,
        boost: 0.6,
        action: () => {
          useWorkspaceStore.getState().openTab({
            type: 'code-editor',
            id: `code-editor:${loc.connectionId}:${loc.schema}.${loc.function.name}`,
            connectionId: loc.connectionId,
            database: loc.database,
            schema: loc.schema,
            objectName: loc.function.name,
            objectType: 'function',
            mode: 'alter',
          });
        },
      });
    }

    return items;
  },
};
